<script>

import Logo from "@/components/Logo.vue";

export default {
    components: {Logo}
}

</script>
<template>
  <div class="about">
    <a href="/"><Logo/></a>
    <h1>{{ $t('privacy_policy.title_label') }}</h1>
  </div>
</template>

<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}
</style>
